import settings from './settings.middleware.js'

export default [
    settings
]